function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChase = function SvgChase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C9 40 0 31 0 20S9 0 20 0s20 9 20 20-9 20-20 20z",
    style: {
      fill: "#1957a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8 5c-.6 0-1 .5-1 1v7.4h19.7l-9-8.4h-9.7M35 15.8c0-.6-.5-1-1-1h-7.4v19.7l8.5-8.9v-9.8M24.2 35c.6 0 1-.5 1-1v-7.4H5.6l8.9 8.5h9.7M5 24.2c0 .6.5 1 1 1h7.4V5.6L5 14.5v9.7",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgChase;